var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    { attrs: { flex: 1 } },
    [
      _c(
        "Box",
        [
          _c("DonorLookup", {
            staticClass: "donor-lookup",
            attrs: { value: _vm.value, disabled: _vm.disabled },
            on: { input: _vm.$listeners.input }
          }),
          _c(
            "layoutText",
            {
              staticClass: "household-address",
              attrs: { color: "#333", "font-size": "2" }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.value && _vm.value.address
                    ? _vm.formatAddress(_vm.value.address)
                    : ""
                )
              )
            ]
          )
        ],
        1
      ),
      _c("Box", { staticClass: "address-info" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }